import { useCallback, useEffect, useRef } from 'react';

/**
 * 根据元素滚动到底部时实现自动加载数据
 */
export const useScrollRequest = ({ scrollTop, isEnd, next, loading, requestStatus }: any, deps: any) => {
  // 新闻列表的外部新闻
  const wrapRef = useRef<HTMLDivElement>(null);
  const size = useRef({ top: 0, height: 0 });
  const viewport = useRef<any>({ width: 0, height: 0 });

  // DOM变化更新值
  const domSize = useCallback((div: HTMLDivElement) => {
    const { top, height } = div.getBoundingClientRect();
    const scrollY = document.documentElement.scrollTop || document.body.scrollTop;
    size.current = { top: top + scrollY, height };
    viewport.current = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }, []);

  useEffect(() => {
    if (!wrapRef.current) return () => {};
    const div = wrapRef.current;
    domSize(div);

    const handler = () => {
      domSize(div);
    };

    window.addEventListener('resize', handler, false);

    return () => {
      window.removeEventListener('resize', handler, false);
    };
  }, [wrapRef.current, domSize, ...deps]);

  // 滚动的时候，开始计算是否需要加载新闻
  useEffect(() => {
    // 如果是0不需要加载
    if (scrollTop === 0) return;
    // 加载完成了不需要再次加载
    if (isEnd) return;
    // 如果在加载中也需要再次加载
    if (loading) return;
    if (requestStatus.current) return; // 正在请求中；

    const { height: vHeight } = viewport.current;
    const { top, height } = size.current;

    if (top + height - scrollTop < vHeight - 20) {
      requestStatus.current = true;
      setTimeout(next, 400);
    }
  }, [scrollTop, isEnd, loading]);
  return {
    divRef: wrapRef,
  };
};
